import Close from "@mui/icons-material/Close";
import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../Modal";

import styles from "./DeleteModal.module.scss";

const DeleteModal = (props) => {
  const { t } = useTranslation();
  const {
    open,
    onClickClose,
    onDelete,
    title,
    deleteButtomLabel = t("delete_popup.delete_button"),
  } = props;

  return (
    <Modal show={open} className={styles.modal} closeModal={onClickClose}>
      <Close className={styles.closeIcon} onClick={onClickClose} />
      <div className={styles.container}>
        <h4 className={styles.title}>{title}</h4>
        <div className={styles.actionDiv}>
          <button className={styles.button} onClick={() => onDelete()}>
            {deleteButtomLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
